export const FILTERS_STORAGE_TOKEN = 'filters-form-state';
export const STORAGE_VERSION = 8;
